<template>
  <div class="d-flex flex-wrap w-100">
    <b-col md="4">
      <p class="text-header">
        Slot Type</p>
    </b-col>
    <b-col md="6">
      <p class="text-child text-justify">
        {{ setString(dataReview.content.slot_type_name) }} </p>
    </b-col>
    <b-col md="4">
      <p class="text-header">
        Medium</p>
    </b-col>
    <b-col md="6">
      <p class="text-child">
        {{ setString(dataReview.content.medium_name) }}</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id !== 3"
      md="4"
    >
      <p class="text-header">
        Action Link</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id !== 3"
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.action_link }}</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="4"
    >
      <p class="text-header">
        Product Name</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.product_name }}</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="4"
    >
      <p class="text-header">
        Product Registry Key</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.product_registry_key }}</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="4"
    >
      <p class="text-header">
        Tariff</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.tarif }}</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="4"
    >
      <p class="text-header">
        Frequency</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.frequency }}</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="4"
    >
      <p class="text-header">
        Shortcode</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.shortcode }}</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="4"
    >
      <p class="text-header">
        CS Number</p>
    </b-col>
    <b-col
      v-if="dataReview.method_id === 3"
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.cs_number }}</p>
    </b-col>

    <!-- Banner 320x50 Preview -->
    <b-col
      v-if="(dataType) ?
        dataReview.content.banner.landscape && dataReview.content.slot_type === '3' && dataReview.method_id !== 3 :
        dataReview.content.slot_type === 3"
      md="4"
    >
      <p class="text-header">
        Banner 320x50</p>
    </b-col>
    <b-col
      v-if="(dataType) ?
        dataReview.content.banner.landscape && dataReview.content.slot_type === '3' && dataReview.method_id !== 3 :
        dataReview.content.slot_type === 3"
      md="6"
    >
      <div
        class="d-flex mb-1"
      >
        <b-img
          :src="(dataType) ? dataReview.content.banner.landscape : bannerLandscapeUrl"
          fluid
          alt="Fluid image"
        />
      </div>
    </b-col>
    <!-- End Banner 320x50 Preview -->

    <!-- Banner 300x250 Preview -->
    <b-col
      v-if="(dataType) ?
        dataReview.content.banner.potrait && dataReview.content.slot_type !== '3' && dataReview.content.slot_type !== '5' || dataReview.method_id === 3:
        dataReview.content.slot_type !== 3 && dataReview.content.slot_type !== 5"
      md="4"
    >
      <p class="text-header">
        Banner 300x250</p>
    </b-col>
    <b-col
      v-if="(dataType) ?
        dataReview.content.banner.potrait && dataReview.content.slot_type !== '3' && dataReview.content.slot_type !== '5' || dataReview.method_id === 3:
        dataReview.content.slot_type !== 3 && dataReview.content.slot_type !== 5"
      md="6"
    >
      <div
        class="d-flex mb-1"
      >
        <b-img
          :src="(dataType) ? dataReview.content.banner.potrait : bannerPotraitUrl"
          fluid
          alt="Fluid image"
        />
      </div>
    </b-col>
    <b-col
      v-if="(dataType) ?
        dataReview.content.slot_type === '2':
        dataReview.content.slot_type === 2"
      md="4"
    >
      <p class="text-header">
        Banner 240 x 400</p>
    </b-col>
    <b-col
      v-if="(dataType) ?
        dataReview.content.slot_type === '2':
        dataReview.content.slot_type === 2"
      md="6"
    >
      <div
        class="d-flex mb-1"
      >
        <b-img
          :src="(dataType) ? dataReview.content.bannerThumbnail : bannerThumbnailUrl"
          fluid
          alt="Fluid image"
        />
      </div>
    </b-col>
    <!-- End Banner 300x250 Preview -->

    <!-- Thumbnail Banner -->
    <b-col
      v-if="(dataType) ?
        dataReview.content.bannerThumbnail && dataReview.method_id === 3 :
        dataReview.method_id === 3 && bannerThumbnailUrl !== '' && dataReview.content.slot_type !== 5 && dataReview.content.slot_type !== 2"
      md="4"
    >
      <p class="text-header">
        Banner Thumbnail</p>
    </b-col>
    <b-col
      v-if="(dataType) ?
        dataReview.content.bannerThumbnail && dataReview.method_id === 3 :
        dataReview.method_id === 3 && bannerThumbnailUrl !== '' && dataReview.content.slot_type !== 5 && dataReview.content.slot_type !== 2"
      md="6"
    >
      <div
        class="d-flex mb-1"
      >
        <b-img
          :src="(dataType) ? dataReview.content.bannerThumbnail : bannerThumbnailUrl"
          fluid
          alt="Fluid image"
        />
      </div>
    </b-col>
    <!-- End Thumbnail Banner -->

    <!-- Video Preview -->
    <b-col
      v-if="(dataType) ?
        dataReview.content.fileVideo && dataReview.content.slot_type === '5' :
        dataReview.content.fileVideo && dataReview.content.slot_type === 5"
      md="4"
    >
      <p class="text-header">
        Video</p>
    </b-col>
    <b-col
      v-if="(dataType) ?
        dataReview.content.fileVideo && dataReview.content.slot_type === '5' :
        dataReview.content.fileVideo && dataReview.content.slot_type === 5"
      md="6"
    >
      <div
        class="d-flex mb-1"
      >
        <video
          id="video-previews"
          fluid
          controls
          class="w-100"
          disablepictureinpicture
          :poster="(dataType) ? dataReview.content.bannerThumbnail : bannerThumbnailUrl"
          :src="(dataType) ? dataReview.content.fileVideo : fileVideoUrl"
        />
      </div>
    </b-col>
    <!-- End Video Preview -->
  </div>
</template>
<script>
import {
  BCol,
  BImg,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BCol,
    BImg,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataReview: Object,
    dataType: {
      default: true,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('campaign', {
      bannerLandscapeUrl: 'getBannerLandscape',
      bannerPotraitUrl: 'getBannerPotrait',
      bannerThumbnailUrl: 'getBannerThumbnail',
      fileVideoUrl: 'getFileVideo',
    }),
  },
  mounted() {
    // console.log(this.dataReview)
  },
  methods: {
    setString(data) {
      let str = (data) || []
      return str.toString()
    },
  },
}
</script>

<style scoped>
.text-header {
  font-size: 14px;
  color: #5E5873;
  font-weight: bold;
}
.text-child {
  font-size: 12px;
  color: #4B6AAE;
}
</style>
